import { cn } from '@/lib/utils'

function colorFor(name: string) {
  let hash = 0
  for (let i = 0; i < name.length; i++) hash = (hash * 31 + name.charCodeAt(i)) % 360
  return `hsl(${hash} 42% 45%)`
}

const sizes = {
  sm: 'h-8 w-8 text-sm',
  md: 'h-10 w-10 text-base',
  lg: 'h-12 w-12 text-lg',
}

export function UserAvatar({
  name,
  src,
  size = 'md',
  className,
}: {
  name: string
  src?: string | null
  size?: keyof typeof sizes
  className?: string
}) {
  const label = (name || '?').trim()
  const initial = label.charAt(0).toUpperCase() || '?'
  const sizeClass = sizes[size]

  if (src) {
    return (
      <img
        src={src}
        alt={label}
        className={cn(
          'shrink-0 rounded-full border border-border object-cover',
          sizeClass,
          className,
        )}
      />
    )
  }

  return (
    <span
      aria-hidden
      className={cn(
        'flex shrink-0 items-center justify-center rounded-full font-semibold text-white',
        sizeClass,
        className,
      )}
      style={{ backgroundColor: colorFor(label) }}
    >
      {initial}
    </span>
  )
}
